// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productCarouselProductStyles } from "@conklin/Overrides/Components/ProductCarouselProduct";
import { css } from "styled-components";

productCarouselProductStyles.productBrandWrapper = {};
productCarouselProductStyles.productPartNumbersStyles = {};
productCarouselProductStyles.productDescriptionStyles = {};
productCarouselProductStyles.productPriceWrapper = {};
productCarouselProductStyles.productUnitOfMeasureSelectStyles = {};
productCarouselProductStyles.addToCartContainer = {};
productCarouselProductStyles.badgeTextWrapper = {
    css: css`
        position: absolute;
        white-space: nowrap;
    `,
};

productCarouselProductStyles.badgeImageWrapper = {
    css: css`
        position: absolute;
        width: 25%;
        height: 25%;
    `,
};

productCarouselProductStyles.badges = {
    css: css`
        margin-bottom: 8px;
    `,
};

productCarouselProductStyles.productActions = {
    addToCartContainer: {
        css: css`
            min-width: 100%;
        `,
    },
};
